import * as e from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Gear.es.js";
const o = e.forwardRef((r, a) => /* @__PURE__ */ e.createElement(t, { ref: a, ...r, weights: m }));
o.displayName = "GearIcon";
const n = o;
export {
  n as Gear,
  o as GearIcon
};
